module.exports = __webpack_public_path__ + "img/freddies_flowers_logo_horizontal.a25c8074.svg";